import React from 'react'
import { twMerge } from 'tailwind-merge'

const BoxLegend = ({ id, className, children, legend, bg, square, border, rounded }) => {
  return (
    <div id={id} className={twMerge("group relative flex flex-col center min-h-64  full ========signal",
      border && "border border1",
      rounded && "rounded-3xl",
      bg && "bg-dark",
      square && "aspect-square",
      className
    )}>

      {children}

      {legend?.trim() &&
        <div className='absolute bottom-0 inset-x-0 padding text-center'>
          <h5 className='muted group-hover:unmute dim group-hover:nodim noaction quick'>{legend}</h5>
        </div>
      }
    </div>
  )
}

export default BoxLegend